import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Header } from '@components/layout';
import { Footer } from '@components/layout';
import { getDealerships } from '@/config/dealerships.config';
import { SchemaMarkup } from '@/components/common/SchemaMarkup';
import { CanonicalTag } from '@/components/common/CanonicalTag';

export const DealershipsIndexPage: React.FC = () => {
    const navigate = useNavigate();
    const dealerships = getDealerships();

    const itemListSchema = {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: 'Car Dealerships in Southern Saskatchewan',
        itemListElement: dealerships.map((dealership, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: dealership.name,
            url: `https://getdrivesource.com${dealership.path}`,
        })),
    };

    return (
        <>
            <CanonicalTag href="https://getdrivesource.com/dealerships" />
            <SchemaMarkup schema={itemListSchema} />
            <Header />
            <div className="pt-20 sm:pt-24 md:pt-28 pb-48 sm:pb-36 px-4 sm:px-6">
                <div className="max-w-3xl mx-auto">
                    {/* Hero */}
                    <div className="text-center mb-10 sm:mb-14">
                        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3">
                            Dealerships
                        </h1>
                        <p className="text-gray-300 text-sm sm:text-base max-w-xl mx-auto">
                            Browse dealerships in southern Saskatchewan. Find new and used vehicles, certified service, and financing options near you.
                        </p>
                    </div>

                    {/* Dealership cards */}
                    <ul className="space-y-2">
                        {dealerships.map(dealership => (
                            <li key={dealership.slug}>
                                <button
                                    onClick={() => navigate(dealership.path)}
                                    className="w-full flex items-center justify-between gap-3 px-4 py-4 rounded-xl bg-[#1a1a1a] hover:bg-cyan-400/10 border border-gray-700 hover:border-cyan-400/40 transition-all text-left group"
                                >
                                    <div className="flex-1 min-w-0">
                                        <span className="block text-sm sm:text-base text-gray-200 group-hover:text-white transition-colors font-semibold">
                                            {dealership.name}
                                        </span>
                                        <span className="block text-xs sm:text-sm text-gray-400 mt-0.5">
                                            {dealership.brand} &middot; {dealership.city}, {dealership.province}
                                        </span>
                                        <span className="block text-xs text-gray-500 mt-0.5">
                                            {dealership.phone}
                                        </span>
                                    </div>
                                    <ChevronRight className="size-4 text-gray-500 group-hover:text-cyan-400 flex-shrink-0 transition-colors" />
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <Footer />
        </>
    );
};
